import { SidebarAccountSettings } from "@/components/sidebar/components/SidebarAccountSettings.tsx";
import { SidebarSettings } from "@/components/sidebar/components/SidebarSettings.tsx";
import { SidebarDocs } from "@/components/sidebar/docs/SidebarDocs.tsx";
import { SidebarHelp } from "@/components/sidebar/help/SidebarHelp.tsx";
import { SidebarRecruitment } from "@/components/sidebar/recruit/SidebarRecruitment.tsx";
import { SidebarReporting } from "@/components/sidebar/reporting/SidebarReporting.tsx";
import { SidebarGoals } from "@/components/sidebar/talent/SidebarGoals.tsx";
import { SidebarReviews } from "@/components/sidebar/talent/SidebarReviews.tsx";
import { SidebarSurveys } from "@/components/sidebar/talent/SidebarSurveys.tsx";
import { SidebarTeam } from "@/components/sidebar/team/SidebarTeam.tsx";
import { SidebarWorkflows } from "@/components/sidebar/workflows/SidebarWorkflows.tsx";
import { ReactNode } from "react";

const teamPanel = <SidebarTeam />;
const recruitmentPanel = <SidebarRecruitment />;
const reviewsPanel = <SidebarReviews />;
const surveysPanel = <SidebarSurveys />;

// requiresItemKey — без него резолвер отдаст панель модуля по адресу, открытому руками без прав.
const panelsByPrefix: { prefix: string; panel: ReactNode; requiresItemKey?: string }[] = [
  { prefix: "/account-settings", panel: <SidebarAccountSettings /> },
  { prefix: "/departments", panel: teamPanel },
  { prefix: "/docs", panel: <SidebarDocs /> },
  { prefix: "/email-confirmed", panel: teamPanel },
  { prefix: "/employees", panel: teamPanel },
  { prefix: "/feedbacks", panel: recruitmentPanel },
  { prefix: "/goals", panel: <SidebarGoals /> },
  { prefix: "/help", panel: <SidebarHelp /> },
  { prefix: "/my-feedback", panel: reviewsPanel },
  { prefix: "/news", panel: teamPanel },
  { prefix: "/performance-reviews", panel: reviewsPanel },
  { prefix: "/recruitment", panel: recruitmentPanel, requiresItemKey: "recruitment" },
  { prefix: "/reporting", panel: <SidebarReporting />, requiresItemKey: "reporting" },
  { prefix: "/settings", panel: <SidebarSettings /> },
  { prefix: "/surveys", panel: surveysPanel },
  { prefix: "/templates/performance-reviews", panel: reviewsPanel },
  { prefix: "/templates/surveys", panel: surveysPanel },
  { prefix: "/time-off", panel: teamPanel },
  { prefix: "/workflows", panel: <SidebarWorkflows />, requiresItemKey: "workflows" },
];

export function resolveSidebarPanel(
  pathname: string,
  visibleItemKeys: ReadonlySet<string>
): ReactNode {
  if (pathname === "/") return teamPanel;

  let matched: { panel: ReactNode; length: number } | undefined;

  for (const { prefix, panel, requiresItemKey } of panelsByPrefix) {
    if (!pathname.startsWith(prefix)) continue;
    if (requiresItemKey !== undefined && !visibleItemKeys.has(requiresItemKey)) continue;
    if (matched === undefined || prefix.length > matched.length) {
      matched = { panel, length: prefix.length };
    }
  }

  return matched?.panel ?? null;
}
